import './ReplaceModal.css';
import { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next'; // Importa o hook de tradução
import { AuthContext } from '../../../../authContext';
import DragAndDrop from '../../../../components/DragAndDrop';

function ReplaceModal({ isOpen, onClose, docToReplace, user, setDocumentList, documentList, setSelectedDocument, triggerUpdate, assistant, sessionId }) {
  const [file, setFile] = useState(null); // Estado para armazenar o novo arquivo PDF
  const { accessToken, setAccessToken } = useContext(AuthContext);
  const [newStatus, setNewStatus] = useState(''); // Estado para armazenar o status do novo arquivo
  const [isLoading, setIsLoading] = useState(false);
  const { t: tDatabase } = useTranslation('database');
  const { t: tCommon } = useTranslation('common');

  if (!isOpen) return null;

  // Função para fechar o modal ao clicar fora do conteúdo
  const handleClickOutside = (event) => {
    if (event.target.classList.contains('modal-overlay-replace')) {
      handleCloseModal();
    }
  };

  // Função para fechar o modal e redefinir estados
  const handleCloseModal = () => {
    setFile(null);
    setNewStatus('');
    onClose();
  };

  // Função para realizar o replace (substituição)
  const handleReplace = () => {
    if (!file || !newStatus) {
      alert(tDatabase('selectFileAndStatus'));
      return;
    }

    // Verifica se já existe um documento com o mesmo nome, diferente do atual
    const fileNameExists = documentList.some(doc =>
      doc.FileName === file.name && doc.FileName !== docToReplace
    );

    if (fileNameExists) {
      alert(tDatabase('documentNameExists'));
      return;
    }


    setIsLoading(true);

    const formData = new FormData();
    formData.append('user', user);
    formData.append('assistant', assistant);
    formData.append('filename', docToReplace);
    formData.append('new_status', newStatus); // Usa o estado do status selecionado
    formData.append('file', file);
    formData.append('session_id', sessionId);

    fetch(`${process.env.REACT_APP_API_URL}/post_replace_document`, {
      method: 'POST',
      headers: {
        "Authorization": `Bearer ${accessToken}`
      },
      body: formData,
    })
      .then(response => response.json())
      .then(data => {
        setDocumentList(prevList => prevList.map(doc =>
          doc.FileName === docToReplace ? { ...doc } : doc
        )); // Atualiza a lista após o replace
        triggerUpdate(); // Atualiza a lista
        setSelectedDocument(null);
        setFile(null);
        setNewStatus('');
        onClose();
      })
      .catch((error) => {
        console.error('Replace Error:', error);
      })
      .finally(() => {
        setIsLoading(false); // Desativa o estado de carregamento
      });
  };

  return (
    <div className="modal-overlay-replace" onClick={handleClickOutside}>
      <div className={`modal-content-replace`}>
        <h3>{tDatabase('replace_file')}</h3>
        <div className="doc-to-replace">{docToReplace}</div>

        {!file && (
          <DragAndDrop setFiles={setFile} multipleFiles={false} acceptedTypes='.pdf' />
        )}

        {file && (
          <div className="file-selected">
            <h3>{tDatabase('loaded_files')}</h3>
            <div className="file-item2">
              <button className="file-button">
                <div className="filename-container">
                  {file.name}
                </div>
                <img
                  src="/imagens/exclude.svg"
                  alt={tDatabase('removeFile')}
                  className="remove-file-icon"
                  onClick={() => setFile(null)}
                />
              </button>
              <select className="status-select" value={newStatus} onChange={(e) => setNewStatus(e.target.value)}>
                <option value="" disabled hidden>{tDatabase('status')}</option>
                <option value="Official">{tDatabase('official')}</option>
                <option value="Draft">{tDatabase('draft')}</option>
              </select>
            </div>
            <button
              className={`replace-button ${isLoading ? 'loading' : ''}`}
              onClick={handleReplace}
              disabled={isLoading}
            >
              {isLoading ? tCommon('loading') : tCommon('replace')}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ReplaceModal;
